import Footer from './Footer';
export { default as Footer } from './Footer';
export { default as FooterGroup } from './FooterGroup';
export { default as FooterSubGroup } from './FooterSubGroup';
export { default as FooterMenuItem } from './FooterMenuItem';

require('xps-style/core/footer.css');

export default Footer;